import {
  buildListPageReplacementAnswers,
  validateListPageEditorRows,
  type ListPageExcelOptions,
} from './editor-model';
import { importListPageWorkbook } from './workbook';

export type ListPageEditorFileResult =
  | { status: 'invalid-template' }
  | { status: 'handled' }
  | { status: 'ready'; rows: unknown[][]; message?: string };

export const readListPageEditorFile = async (
  file: File,
  options: ListPageExcelOptions,
): Promise<ListPageEditorFileResult> => {
  const result = await importListPageWorkbook(file, options);
  if (result.status === 'invalid-template') return result;
  return {
    status: 'ready',
    rows: result.rows ?? [],
    message:
      result.status === 'invalid'
        ? `${result.errorCount} validation error${result.errorCount === 1 ? '' : 's'} found. Fix the red cells before saving.`
        : undefined,
  };
};

export const importListPageWorkbooks = async (files: File[], options: ListPageExcelOptions) => {
  const results = [];
  for (const file of files) {
    const result = await importListPageWorkbook(file, options);
    if (result.status !== 'valid') {
      return result.status === 'invalid'
        ? { ...result, message: `${file.name}: ${result.message}` }
        : result;
    }
    results.push(result);
  }
  if (results.length === 1) return results[0];
  const rows = results.flatMap((result) => result.rows || []);
  const validation = validateListPageEditorRows(options, rows);
  if (validation.errors.length)
    throw new Error(
      'The combined rows contain validation errors. Check the files before importing.',
    );
  return {
    status: 'valid' as const,
    answers: buildListPageReplacementAnswers(options, validation.rows),
    responseCount: validation.rows.length,
    rows,
  };
};
